// Cookie Policy for CareerOS-AI.
import { Link } from "react-router-dom";
import LegalLayout, { bullets } from "./LegalLayout";

const EFFECTIVE = "July 16, 2026";

const SECTIONS = [
  { n: 1, id: "what-are-cookies", title: "What are cookies?",
    body: (<>
      <p>Cookies are small text files stored on your device by your browser when you visit a website. Similar technologies (local storage, session storage, web beacons, SDKs) are covered by this policy too.</p>
      <p>We use these technologies to remember you between visits, keep you logged in, and understand how CareerOS-AI is used.</p>
    </>) },
  { n: 2, id: "categories", title: "The categories we use",
    body: (<>
      <p><strong>Strictly necessary</strong> — required to run the Service. Includes your auth session, CSRF/anti-abuse tokens, and preference storage (e.g. dark/light mode, sidebar collapsed state). You cannot opt out of these without breaking the Service.</p>
      <p><strong>Preference</strong> — remember your currency, timezone, and UI choices so we don&apos;t re-ask on every page.</p>
      <p><strong>Analytics</strong> — measure aggregate feature usage, page performance, and errors. Configured to avoid capturing your resume, chat, or profile content.</p>
      <p><strong>Marketing</strong> — currently we do not use marketing cookies. If we ever add them, we will ask for consent first.</p>
    </>) },
  { n: 3, id: "third-parties", title: "Third-party cookies",
    body: (<>
      <p>Some cookies are set by our service providers on our behalf:</p>
      {bullets([
        "Stripe — payment session and fraud prevention on checkout pages.",
        "Emergent-managed authentication — session identifier when you sign in with Google.",
        "Analytics / error monitoring providers — see the Analytics category above.",
      ])}
      <p>These providers may use cookies subject to their own privacy policies.</p>
    </>) },
  { n: 4, id: "your-choices", title: "Your choices",
    body: (<>
      {bullets([
        "You can clear cookies from your browser at any time. Doing so will sign you out.",
        "You can block all cookies in your browser settings — CareerOS-AI will not function correctly.",
        "Where required by law (EU/UK/Canada), we present a consent banner on your first visit for non-essential cookies.",
        "You can withdraw consent at any time by revisiting the banner from the site footer.",
      ])}
    </>) },
  { n: 5, id: "do-not-track", title: "Do Not Track",
    body: <p>Our Service currently does not respond to browser &quot;Do Not Track&quot; signals because no consensus standard exists for them. We respect the explicit choices you make in our own consent banner and in your account settings.</p> },
  { n: 6, id: "changes", title: "Changes to this policy",
    body: <p>We may update this Cookie Policy as we add or remove technologies. Material changes will be communicated on the website. The &quot;Last Updated&quot; date reflects the current version.</p> },
  { n: 7, id: "contact", title: "Contact us",
    body: (<>
      <p>Questions? Email <a className="font-mono" href="mailto:support@careeros-ai.com">support@careeros-ai.com</a> or read our <Link to="/privacy">Privacy Policy</Link>.</p>
    </>) },
];

const INTRO = (
  <p>This Cookie Policy explains how CareerOS-AI uses cookies and similar technologies on our website and web app. It complements our <Link to="/privacy">Privacy Policy</Link>.</p>
);

export default function CookiePolicy() {
  return (
    <LegalLayout
      eyebrow="Legal · Cookies"
      title="Cookie Policy"
      subtitle="for CareerOS-AI"
      effectiveDate={EFFECTIVE}
      lastUpdated={EFFECTIVE}
      intro={INTRO}
      sections={SECTIONS}
      currentPath="/cookies"
    />
  );
}
